export default __webpack_public_path__ + "static/char-18-bc2b87edd0c177829fc146427c4460bc.gif";